import { render, staticRenderFns } from "./view.html?vue&type=template&id=718ca31e&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./event.less?vue&type=style&index=0&id=718ca31e&scoped=true&lang=less&"
import style1 from "./mobile.less?vue&type=style&index=1&id=718ca31e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718ca31e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('718ca31e')) {
      api.createRecord('718ca31e', component.options)
    } else {
      api.reload('718ca31e', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=718ca31e&scoped=true&", function () {
      api.rerender('718ca31e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/event1/index.vue"
export default component.exports